import { render } from "./FooterComp.vue?vue&type=template&id=116fe64d&ts=true"
import script from "./FooterComp.vue?vue&type=script&lang=ts"
export * from "./FooterComp.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\manya\\Documents\\Development\\Production\\Vue\\bbf-africa-website\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__